export default "__VITE_ASSET__sMl$ANy4__"